import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  updateRedeemPopup,
  fetchRoundPageCategory,
  updatePotTokenValue,
  updateSelectedPot,
  updateMyRound,
  fetchRoundToJoinData,
} from "../Pages/RoundToJoin/roundToJoin.slice";

import axios from "axios";
import useToastMessage from "../Utiles/Toaster";
import toast, { Toaster } from "react-hot-toast";
import { createTokenModalOpen, tokenRedeemUpdate, updateTokenError } from "../Pages/RoundToJoin/tocken.slice";
import { useNavigate } from "react-router";
import { updateMypot } from "../Pages/Dashboard/dashboard.slice";
import { refreshTokenV2 } from "../services/api";
import { baseURL } from "../services/axiosConfig";

function TokenRedeemPopUp({ round }) {
  const navigate = useNavigate();
  const { showToast, showErrorToast } = useToastMessage();
  const dispatch = useDispatch();
  const { tokenRemaining, pickRemains, roundToJoinPotData, leagueId } =
    useSelector((state) => state.roundToJoin);

  const [isPlayNowBtnEnabled, setIsPlayNowBtnEnabled] = useState(true)

  let [pickRemain, setPickRemains] = useState(pickRemains)
  const potTokenValue = useSelector((state) => state.roundToJoin.potTokenValue);
  const [tokenCount, setTokenCount] = useState(1);
  const [tokenOptions, setTokenOptions] = useState([]);
  const potId = useSelector((state) => state.roundToJoin.selectedPot);

  const popupRef = useRef();

  const rountMyRound = useSelector((state) => state.roundToJoin.myRound);

  const dashbordRound = useSelector((state) => state.dashboard);

  const roundsToJoin = useSelector(
    (state) => state.dashboard.potInfo.roundsToJoin
  );

  useEffect(() => {
    // Close on outside click
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        dispatch(updateRedeemPopup(false));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dispatch]);

  useEffect(() => {
    if (pickRemain === 2) {
      setTokenOptions([
        { value: 1, label: "1 Pick", price: 1 * potTokenValue },
        { value: 2, label: "2 Picks", price: 2 * potTokenValue },
      ]);
    } else {
      setTokenOptions([
        { value: 1, label: "1 Pick", price: 1 * potTokenValue },
      ]);
    }
  }, [pickRemain, potTokenValue]);

  const roundToJoinPot = async () => {
    try {
      setIsPlayNowBtnEnabled(false)
      let path = window.location.pathname;
      const token = localStorage?.getItem("access_token");
      const userInfo = JSON.parse(localStorage?.getItem("userInfo"));
      const res = await axios.post(
        `${baseURL}/pot/joinpot`,
        {
          number_of_picks: tokenCount,
          pot: potId,
          player: userInfo.userId,
        },
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(token)}`,
          },
        }
      );
      if (res.data) {
        const userId = userInfo ? userInfo.userId : null;
        window.dataLayer.push({
          'userId': userId,
          'event': 'click',
          'clickText': 'Play Now Modal',
          'clickID': 'btn-play-now-modal',
          'clickURL': '',
          'roundId': potId,
          'leagueId': leagueId,
          'tokenCount': tokenCount,
          'sportId': res?.data?.game_name || ""
        });

        window.dataLayer.push({
          'userId': userId,
          'event': 'enter_round',
          'roundId': potId,
          'fixtureId': roundsToJoin.season_name,
          'entryType': 'tokens',
          'tokenCost': tokenCount * potTokenValue
        });
        setIsPlayNowBtnEnabled(true)
        const updatedRoundToJoin = roundToJoinPotData.map((ele) => {
          if (ele.league_id === leagueId) {
            return {
              ...ele,
              pots: ele.pots.filter((item) => item.id !== potId), // keep pots where id ≠ potId
            };
          }
          return ele;
        });

        dispatch(fetchRoundToJoinData({ roundToJoinPot: updatedRoundToJoin }));
        if (path === "/rounds" && pickRemains === 1) {
          let newPick = {
            pick_id: res.data.id ? res.data.id : res.data.data.id,
            pick_number: "2/2",
            prediction: {
              team: "NPY",
              team_type: "NPY",
              logo: null,
              short_name: null,
              system: false,
            },
            round: 0,
            status: res.data.status,
            username: res.data.username,
          };

          let updatedRounds = rountMyRound.map((ele) => {
            if (ele.id === potId) {
              return {
                ...ele,
                net_pot_value: res?.data?.data?.net_pot_value,
                active_picks_count: ele.active_picks_count + 1,
                pick_id: [...ele.pick_id, newPick],
              };
            }
            return ele;
          });
          dispatch(updateMyRound(updatedRounds));
        }

        if (path === "/dashboard") {
          let updatedRoundsToJoin = roundsToJoin.map((round, index) => {
            if (index === 0) {
              return {
                ...round,
                pots: round.pots.filter((ele) => ele.id !== potId),
              };
            }
            return round;
          });
          dispatch(updateMypot(updatedRoundsToJoin));
        }

        dispatch(tokenRedeemUpdate(tokenCount * potTokenValue));
        showToast("Successfully joined the pot!");
        dispatch(updateSelectedPot(""));
        dispatch(updateRedeemPopup(false));
        dispatch(fetchRoundPageCategory("myRound"));
        navigate("/rounds", { state: { myRound: true } });
      } else {
        setIsPlayNowBtnEnabled(true)
        dispatch(updateRedeemPopup(false));
        dispatch(updateSelectedPot(""));
        showErrorToast("No data returned from the server.");
      }
    } catch (error) {
      setIsPlayNowBtnEnabled(true)
      if (error?.response?.status === 401) {
        refreshTokenV2(dispatch);
      }
      dispatch(updateRedeemPopup(false));
      dispatch(updateSelectedPot(""));
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong. Please try again.";
      if (errorMessage === "Not enough tokens to join please buy tokens") {
        dispatch(createTokenModalOpen(true));
        dispatch(updateTokenError(true))
      }
      // showErrorToast(errorMessage);
    }
  };

  useEffect(() => {
    let path = window.location.pathname;
    if (path === '/dashboard') {
      let potInfo = dashbordRound?.potInfo?.roundsToJoin[0]?.pots.find((ele) => ele.id === potId);
      let onePotVal = potInfo?.pot_token * potInfo?.token_value;
      if (potInfo?.max_pot_value > potInfo?.current_pot_value) {
        if ((potInfo?.max_pot_value - potInfo?.current_pot_value) >= onePotVal * 2) {
          setPickRemains(potInfo.max_number_of_picks ? potInfo.max_number_of_picks : 2)
        }
        else if ((potInfo?.max_pot_value - potInfo?.current_pot_value) >= onePotVal) {
          setPickRemains(1)
        } else {
          // showErrorToast('Error')
        }
      } else {

      }
    }

    if (path === '/rounds') {
      let leagueData = roundToJoinPotData?.find((ele) => ele?.league_id === leagueId);
      let potInfo = leagueData?.pots?.filter((ele) => ele?.id === potId);
      let onePotVal = potInfo?.[0]?.pot_token * potInfo?.[0]?.token_value;

      if (potInfo?.[0]?.max_pot_value > potInfo?.[0]?.current_pot_value) {
        if ((potInfo?.[0]?.max_pot_value - potInfo?.[0]?.current_pot_value) >= onePotVal * 2) {
          setPickRemains(potInfo[0].max_number_of_picks ? potInfo[0].max_number_of_picks : 2);
        } else if ((potInfo?.[0]?.max_pot_value - potInfo?.[0]?.current_pot_value) >= onePotVal) {
          setPickRemains(1);
        } else {
          // showErrorToast('Error');
        }
      }
    }
  }, [potId])



  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex justify-center items-center p-4">
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            // color: "#1BA56F",
            fontWeight: "700",
            borderRadius: "0px !important",
            border: `1px solid #1BA56F`,
          },
        }}
      />
      <div
        ref={popupRef}
        className="bg-white rounded-lg shadow-lg w-full max-w-sm max-h-[90vh] flex flex-col overflow-hidden relative"
      >
        {/* Close Button (X) */}
        <button
          onClick={() => dispatch(updateRedeemPopup(false))}
          className="absolute top-2 right-2 text-gray-600 text-2xl hover:text-black"
        >
          &times;
        </button>

        {/* Pick Options */}
        <div className="flex justify-center gap-4 p-6 pt-10">
          {tokenOptions.map((option) => (
            <button
              key={option.value}
              onClick={() => setTokenCount(option.value)}
              className={`border rounded-lg py-2 px-10 text-center transition ${tokenCount === option.value
                ? "border-[#00D56F] bg-[#E6FFF5]"
                : "border-gray-300"
                }`}
            >
              <div className="font-semibold">{option.label}</div>
              <div className="text-sm text-gray-500">{option.price} {option.price === 1 ? 'Token' : 'Tokens'}</div>
            </button>
          ))}
        </div>

        {/* Selected Pick Info */}
        <p className="text-center text-gray-700 font-medium mb-4">
          Selected: {tokenCount} Pick{tokenCount > 1 ? "s" : ""}
        </p>

        {/* Footer Buttons */}
        <div className="p-4 justify-center flex gap-3">
          <button
            className="p-4 border border-gray-300 text-black font-semibold text-base sm:text-lg py-1 sm:py-2 rounded-lg shadow-sm transition"
            onClick={() => dispatch(updateRedeemPopup(false))}
          >
            Cancel
          </button>
          <button
            className={`p-4
              ${isPlayNowBtnEnabled ? 'bg-[#00C05B]' : 'bg-gray-500 cursor-not-allowed'}
                text-white font-bold text-base
                sm:text-lg py-1 sm:py-2 rounded-lg shadow-lg
                 transition`}
            onClick={isPlayNowBtnEnabled && roundToJoinPot}
            disabled={isPlayNowBtnEnabled === false ? true : false}
          >
            Play Now
          </button>
        </div>
      </div>
    </div>
  );
}

export default TokenRedeemPopUp;
